import { render, staticRenderFns } from "./ReturnProductReceipt.vue?vue&type=template&id=0770dc82&scoped=true&"
import script from "./ReturnProductReceipt.vue?vue&type=script&lang=js&"
export * from "./ReturnProductReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770dc82",
  null
  
)

export default component.exports